import { FastField, FieldArray, useField } from "formik"
import { Alert, Button, Grid, Paper } from "@mui/material"
import { InputExample } from "../FormFields/InputExample"
import { DatePickerField, InputField, SelectField } from "../FormFields"
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import React from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

const WorkExperienceItem = ({ index }) => {

  const [DescriptionField] = useField({ name: `PersonEmployment[${index}].FullDescription__c`})
  const [EmployerField] = useField({ name: `PersonEmployment[${index}].Name`})
  const [EndDateField] = useField({ name: `PersonEmployment[${index}].EndDate`})
  const [LocationField] = useField({ name: `PersonEmployment[${index}].EmployerCountry`})
  const [PositionField] = useField({ name: `PersonEmployment[${index}].Position`})
  const [StartDateField] = useField({ name: `PersonEmployment[${index}].StartDate`})
  const optionsCountries = useSelector(state => state.salesforce.countries)
  // const currentYear = new Date().getFullYear()
  const { t } = useTranslation()

  return (
    <>
      <Grid item sm={6} xs={12}>
        <FastField component={InputExample} label={t('PersonEmployment.Name')} name={EmployerField.name} />
      </Grid>
      <Grid item sm={6} xs={12}>
        <SelectField data={optionsCountries} fullWidth label={t('PersonEmployment.EmployerCountry')} name={LocationField.name} required />
      </Grid>
      <Grid item sm={4} xs={12}>
        <FastField component={InputExample} label={t('PersonEmployment.Position')} name={PositionField.name} />
      </Grid>
      <Grid item sm={4} xs={12}>
        <DatePickerField fullWidth inputFormat="MM/yyyy" label={t('PersonEmployment.StartDate')} name={StartDateField.name} views={['month', 'year']} />
      </Grid>
      <Grid item sm={4} xs={12}>
        <DatePickerField fullWidth inputFormat="MM/yyyy" label={t('PersonEmployment.EndDate')} name={EndDateField.name} views={['month', 'year']} />
      </Grid>
      <Grid item xs={12}>
        <InputField fullWidth label={t('PersonEmployment.FullDescription__c')} minRows={3} multiline name={DescriptionField.name} required />
      </Grid>
    </>
  )
}

const WorkExperience = () => {

  const accountId = useSelector(state => state.salesforce.account.Id)
  const { t } = useTranslation()

  return (
    <FieldArray name="PersonEmployment">
      {({ form, ...fieldArrayHelpers }) => {
        const onAddClick = (e) => {
          e.preventDefault()
          fieldArrayHelpers.push({
            // Id: form.values.PersonEmployment.length,
            AccountId: accountId,
            RelatedPersonId: accountId,
            Description: '',
            Name: '',
            EndDate: '',
            EmployerCountry: '',
            Position: '',
            StartDate: ''
          })
        }
        const onRemoveClick = (e, index) => {
          e.preventDefault()
          fieldArrayHelpers.remove(index)
        }
        return (
          <>
            {form.values.PersonEmployment.length === 0 && <Alert elevation={6} severity="info">{t('experience.info')} <strong>{t('experience.button', { other: '' })}</strong>.</Alert>}
            <Paper sx={{ display: form.values.PersonEmployment.length === 0 ? 'none' : 'block' }}>
              <Grid alignItems="center" container spacing={3} sx={{ m:0, pl: 0, pr: 12, pt: 3, pb: 3 }}>
                {form.values.PersonEmployment.map((work, index) => (
                  <React.Fragment key={index}>
                    <WorkExperienceItem
                    index={index}
                    />
                    <Grid item sm={12}>
                      <Button color="error" onClick={(e) => { onRemoveClick(e, index)}} startIcon={<DeleteForeverIcon />} variant="text">{t('experience.delete')}</Button>
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Paper>
            <Button onClick={onAddClick} variant="outlined" sx={{ mt: 2 }}>{t('experience.button', { other: form.values.PersonEmployment.length > 0 ? t('experience.other') : '' })}</Button>
          </>
        )
      }}
    </FieldArray>
  )
}

export default WorkExperience
